import { render, staticRenderFns } from "./WXCW81Import.vue?vue&type=template&id=2fd0ea58&"
import script from "./WXCW81Import.vue?vue&type=script&lang=js&"
export * from "./WXCW81Import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports